import { Text } from '@inflearn/ds-react-next';

export function UserSlug({ slug }: { slug: string }) {
  return (
    <Text size="md" fw="400" lh="1.3" c="gray.6">
      @{slug}
    </Text>
  );
}
